<template>
    <v-container grid-list-xl fluid>
        <v-layout align-center>
            <v-flex>
                <h3 class="page-header">{{event_data.title}}</h3>
                <h4>{{get_event_period}}</h4>
            </v-flex>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="editEvent()">{{$t('action.edit')}}</v-btn>
            <!--<v-btn color="primary">Delete</v-btn>-->
        </v-layout>

        <v-tabs
                dark
                slider-color="white"
                color="blue"
                left
        >
            <v-tab
              key="event_dashboard"
            >
                {{$t('event.dashboard')}}
            </v-tab>
            <v-tab
              key="registrations"
            >
                {{$t('event.registrations')}}
            </v-tab>
            <v-tab
              v-if="show_payment_related"
              key="payment_report"
            >
                {{$t('event.payment_report')}}
            </v-tab>
            <v-tab
              key="event_media"
            >
                {{$t('event.media')}}
            </v-tab>
            <v-tab
                    key="event_story">
                {{$t('event.story')}}
            </v-tab>
            <v-tab
                key="activity">
                {{$t('event.activity')}}
            </v-tab>
            <v-tab-item
              key="event_dashboard"
            >
                <v-card flat>
                    <v-card-text>

                        <v-layout row wrap>
                            <v-flex lg3 sm6 xs6 @click="showAttendeeNameList">
                                <mini-statistic
                                        icon="fas fa-users"
                                        :title="stat_attendee_count_text"
                                        :sub-title="stat_attendee_count_title"
                                        color="red"
                                >
                                </mini-statistic>
                            </v-flex>

                            <v-flex lg3 sm6 xs6 @click="showRegistrationNameList">
                                <mini-statistic
                                        icon="far fa-calendar-plus"
                                        :title="getTotalRegistrationCount().toString()"
                                        :sub-title="$t('event.registrations_no')"
                                        color="purple"
                                >
                                </mini-statistic>
                            </v-flex>

                            <v-flex lg3 sm6 xs6 v-if="event_data.ask_for_attend" @click="showMaybeNameList">
                                <mini-statistic
                                        icon="fas fa-question-circle"
                                        :title="event_data.stats.maybe_count.toString()"
                                        :sub-title="$t('event.maybe_no')"
                                        color="primary"
                                >
                                </mini-statistic>
                            </v-flex>

                            <v-flex lg3 sm6 xs6 v-if="event_data.ask_for_attend" @click="showExcuseNameList">
                                <mini-statistic
                                        icon="far fa-calendar-times"
                                        :title="event_data.stats.decline_count.toString()"
                                        :sub-title="$t('event.excused_no')"
                                        color="blue-grey"
                                >
                                </mini-statistic>
                            </v-flex>

                        </v-layout>


                        <v-layout v-if="!event_data.is_private" row wrap>
                            <v-flex lg6 sm12>
                                <h2>{{ $t('event.registration_url') }}</h2>

                                <v-layout row wrap>

                                    <v-flex xs12 class="pb-0">
                                        <v-text-field
                                                :label="$t('event.registration_url')"
                                                class="text-field-without-message"
                                                v-model="this.registration_url"
                                                outline
                                                readonly
                                        >
                                            <template slot="append">
<!--                                                <v-tooltip bottom>-->
<!--                                                    <v-icon slot="activator" @click="copyUrl(registration_url)">fa-copy fa-fw</v-icon>-->
<!--                                                    <span>{{$t('action.copy')}}</span>-->
<!--                                                </v-tooltip>-->
<!--                                                <v-tooltip bottom>-->
<!--                                                    <v-icon slot="activator" @click="copyUrl(registration_url)">share</v-icon>-->
<!--                                                    <span>{{$t('action.share')}}</span>-->
<!--                                                </v-tooltip>-->
                                                <v-menu bottom left>
                                                    <v-icon slot="activator">more_vert</v-icon>
                                                    <v-list>
                                                        <v-list-tile
                                                                @click="copyUrl(registration_url)"
                                                        >
                                                            <v-list-tile-title>{{$t('action.copy')}}</v-list-tile-title>
                                                        </v-list-tile>
                                                        <v-list-tile
                                                                @click="gotoUrl(registration_url)"
                                                        >
                                                            <v-list-tile-title>{{$t('action.open')}}</v-list-tile-title>
                                                        </v-list-tile>
                                                    </v-list>
                                                </v-menu>
                                            </template>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <div v-if="has_navigation_share">
                                            <v-btn color="primary" @click="shareRegistration()">{{$t('action.share')}}</v-btn>
                                        </div>
                                       <div v-else>
                                           <div>{{$t('event.msg_share_registration_url')}}:</div>
                                           <div>
                                               <v-btn class="ml-0 mr-1" color="green" icon dark @click="shareWithWhatsapp()">
                                                   <v-icon>fab fa-whatsapp</v-icon>
                                               </v-btn>
                                               <v-btn class="ml-0 mr-1" color="indigo" icon dark target="_blank" @click="shareWithFacebook()">
                                                   <v-icon>fab fa-facebook-f</v-icon>
                                               </v-btn>
                                           </div>
                                       </div>
                                    </v-flex>
                                </v-layout>
                            </v-flex>

                            <!--<v-flex lg6 sm12>-->
                                <!---->
                            <!--</v-flex>-->

                        </v-layout>

                        <template v-if="show_invitations">
                            <v-layout row wrap align-center>
                                <v-flex>
                                    <h2>{{ $t('event.invitations') }}</h2>
                                </v-flex>
                                    <v-btn
                                        v-if="!eventStarted"
                                        fab
                                        absolute
                                        right
                                        color="primary"
                                        @click="showInviteDialog({})"
                                    >
                                        <v-icon>add</v-icon>
                                    </v-btn>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-card>
                                        <ajax-data-iterator
                                            ref="invitationIterator"
                                            :get_url="get_invitations_url"
                                            :url_query="get_url_query"
                                        >
                                            <template slot-scope="props">
                                                <v-list-tile
                                                    :key="props.item.id"
                                                    avatar
                                                    @click="showInviteDialog(props.item)"
                                                >
                                                    <v-list-tile-avatar>
                                                        <v-icon>people</v-icon>
                                                    </v-list-tile-avatar>
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>
                                                            <v-layout row ma-0>
                                                                <span>{{$t('contact.n_contacts', [props.item.contacts.length])}} - {{props.item.created_timestamp | moment("LLL")}}</span>
                                                            </v-layout>
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                            </template>
                                        </ajax-data-iterator>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </template>
                    </v-card-text>
                </v-card>

            </v-tab-item>
            <v-tab-item
                    key="registrations"
            >
                <v-card flat>
                    <v-card-text>

                        <v-layout>
                            <!--<v-spacer></v-spacer>-->
                            <v-btn
                                    v-if="!isEventFull && !eventStarted"
                                    fab
                                    fixed
                                    right
                                    bottom
                                    color="primary"
                                    class="mb-5"
                                    @click="editRegistration(null)"
                            >
                                <v-icon>add</v-icon>
                            </v-btn>
                        </v-layout>

                        <v-layout row wrap>


                            <v-flex sm6 md3 class="py-1">
                                <v-text-field
                                        prepend-icon="search"
                                        @input="searchRegistrations"
                                        :label="$t('registration.search_by_name')"
                                        v-model="registration_list.params.contact_name"
                                        clearable
                                        :loading="registration_list.searching"
                                ></v-text-field>
                            </v-flex>

                            <v-flex sm6 md3 v-if="show_payment_related" class="py-1">
                                <v-select
                                        @input="searchRegistrations"
                                        v-model="registration_list.params.payment_status"
                                        :items="payment_status_items"
                                        item-text="text"
                                        item-value="value"
                                        :label="$t('deposit_transaction.payment_status')"
                                        multiple
                                        clearable
                                        :loading="registration_list.searching"
                                ></v-select>
                            </v-flex>

                            <v-flex sm6 md3 class="py-1">
                                <v-select
                                        @input="searchRegistrations"
                                        v-model="registration_list.params.sort_by"
                                        :items="registration_sorting_items"
                                        :label="$t('general.sort_by')"
                                        item-text="text"
                                        item-value="value"
                                        :loading="registration_list.searching"
                                >

                                </v-select>
                            </v-flex>

                            <v-flex sm6 md3 v-if="event_data.ask_for_attend" class="py-1">
                                <v-select
                                        @input="searchRegistrations"
                                        v-model="registration_list.params.registration_status"
                                        :items="registration_status_items"
                                        item-text="text"
                                        item-value="value"
                                        :label="$t('registration.registration_status')"
                                        multiple
                                        clearable
                                        :loading="registration_list.searching"
                                ></v-select>
                            </v-flex>

                        </v-layout>

                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-card class="elevation-0">

                                    <ajax-data-iterator
                                        ref="registrationListIterator"
                                        :get_url="get_registrations_url"
                                        :url_query="registration_list.params"
                                        :response_callback_function="getRegistrationCallback"
                                        :item_handle_function="processRegistrationItem"
                                        content_tag="v-layout"
                                        content_class="row wrap"
                                    >
                                        <template slot-scope="props">
                                            <v-flex xs12 class="pb-2">
                                                <v-hover>
                                                    <v-card
                                                            class="registration-item"
                                                            @click="showRegistration(props.item)"
                                                            slot-scope="{ hover }"
                                                            :color="(hover ? 'grey lighten-4' : '')"
                                                    >
                                                        <v-card-text primary-title class="py-4 pl-4">
                                                            <v-layout align-center>
                                                                <v-icon x-large class="pr-2">
                                                                    list_alt
                                                                </v-icon>
                                                                <div class="registration-info-wrapper">
                                                                    <v-layout row wrap align-center>
                                                                        <v-flex md6 xs8>
                                                                            <div class="font-weight-bold" style="font-size: 1.2em">
                                                                                <v-icon v-if="props.item.pinned_to_top" size="18">fas fa-arrow-up</v-icon>
                                                                                {{props.item.full_contact_name}}
                                                                                <span v-if="props.item.attendee_count > 1">({{props.item.attendee_count}})</span>
                                                                            </div>
                                                                            <div>{{props.item.contact.areaCode}} {{props.item.contact.phone}}</div>
                                                                        </v-flex>
                                                                        <v-flex md6 xs4>
                                                                            <div>
                                                                                <v-chip v-if="show_payment_related && props.item.status == 1" :color="getPaymentStatusColor(props.item.deposit_payment_status)" text-color="white" small disabled>{{$t('payment_status.' + props.item.deposit_payment_status)}}</v-chip>
                                                                            </div>
                                                                        </v-flex>
                                                                        <div class="registration-status-wrapper">
                                                                            <v-chip label :color="getRegistrationStatusColor(props.item.status)" text-color="white" small disabled>{{$t('registration_status.' + props.item.status)}}</v-chip>
                                                                        </div>
                                                                    </v-layout>
                                                                </div>
                                                                <!--<v-spacer></v-spacer>-->
                                                                <!--<v-menu-->
                                                                        <!--v-model="props.item.show_menu"-->
                                                                        <!--bottom-->
                                                                        <!--left-->
                                                                <!--&gt;-->
                                                                    <!--<v-btn-->
                                                                            <!--slot="activator"-->
                                                                            <!--icon-->
                                                                            <!--@click.capture.stop="props.item.show_menu = true"-->
                                                                    <!--&gt;-->
                                                                        <!--<v-icon>more_vert</v-icon>-->
                                                                    <!--</v-btn>-->

                                                                    <!--<v-list>-->
                                                                        <!--<v-list-tile-->
                                                                                <!--:key="1"-->
                                                                                <!--@click="showRegistration(props.item)"-->
                                                                        <!--&gt;-->
                                                                            <!--<v-list-tile-title>{{$t('action.view')}}</v-list-tile-title>-->
                                                                        <!--</v-list-tile>-->
                                                                    <!--</v-list>-->

                                                                <!--</v-menu>-->
                                                            </v-layout>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-hover>
                                            </v-flex>
                                        </template>
                                    </ajax-data-iterator>

                                    <div class="text-xs-left pt-2">
                                        <v-btn color="primary" :href="exportEventAttendeeListUrl()" target="_blank">{{$t('action.export')}} ({{$t('general.to_excel')}})</v-btn>
                                        <v-btn color="primary" @click="exportRegistrantsList()">
                                            {{$t('event.share_registration_details')}}
                                        </v-btn>
                                        <v-btn color="primary" :href="event_data.registration_details_url" target="_blank">{{$t('event.view_registration_details')}}</v-btn>
                                    </div>

                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item
              v-if="show_payment_related"
              key="payment_report">
                <v-card flat>
                    <v-card-text>

                        <v-layout row wrap>

                            <v-flex sm6 md3>
                                <v-select
                                        @input="searchPayments"
                                        v-model="payment_records.params.payment_methods"
                                        :items="payment_method_items"
                                        item-text="text"
                                        item-value="value"
                                        :label="$t('deposit_transaction.payment_method')"
                                        multiple
                                        clearable
                                        :loading="payment_records.searching"
                                ></v-select>
                            </v-flex>

                        </v-layout>

                        <v-layout>
                            <v-flex xs12>
                                <div class="heading-total-received">{{$t('deposit_transaction.total_received')}}: {{utils.toCurrencyFormat(payment_records.total_received)}}</div>
                            </v-flex>
                        </v-layout>

                        <ajax-data-iterator
                                ref="paymentRecordIterator"
                                :get_url="get_payment_received_url"
                                :url_query="payment_records.params"
                                :response_callback_function="getPaymentReceivedCallback"
                                content_tag="v-layout"
                                content_class="row wrap"
                                :loading="payment_records.searching"
                        >
                            <template slot-scope="props">
                                <v-flex xs12 class="pb-0">
                                    <v-card>
                                        <v-card-text primary-title class="py-4 pl-4">
                                                <v-layout row wrap align-center>
                                                    <v-flex xs12 sm3>
                                                        <v-layout row wrap align-center class="pb-3">
                                                            <v-flex xs6 sm12 class="py-0">
                                                                <div class="font-weight-bold">{{props.item.registration.full_contact_name}} {{props.item.registration.status == 9 ? ("(" + $t('registration.cancelled') + ")") : ""}}</div>
                                                            </v-flex>
                                                            <v-flex xs6 sm12 class="py-0">
                                                                {{$t('event.attendees')}}: {{props.item.registration.attendee_count}}
                                                            </v-flex>
                                                            <v-flex xs12 class="py-0">
                                                                {{$t('deposit_transaction.total')}}: {{utils.toCurrencyFormat(props.item.registration.deposit_amount)}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm9>

                                                        <v-layout row wrap align-center>
                                                            <v-flex xs12 class="py-0">
                                                                <div class="font-weight-bold">{{$t('deposit_transaction.payments')}}</div>
                                                            </v-flex>
                                                        </v-layout>

                                                        <template v-for="(payment, index) in props.item.payments">
                                                            <v-layout
                                                                :key="index"
                                                                row wrap align-center class="payment-record-row"
                                                            >
                                                                <v-flex xs4 sm2 class="py-0">{{utils.toCurrencyFormat(payment.payment_amount)}}</v-flex>
                                                                <v-flex xs8 sm4 class="py-0">{{payment.payment_time | moment("L LT")}}</v-flex>
                                                                <v-flex xs4 sm2 class="py-0">{{$t('payment_methods.' + payment.payment_method)}}</v-flex>
                                                                <v-flex xs8 sm4 class="py-0">{{$t('deposit_transaction.ref')}}: {{payment.payment_ref?payment.payment_ref:'--'}}</v-flex>
                                                            </v-layout>
                                                        </template>


                                                        <v-layout row wrap align-center>
                                                            <v-flex xs6 sm12 class="py-0">
                                                                <div class="font-weight-bold">{{$t('deposit_transaction.total_received')}}: {{utils.toCurrencyFormat(getPaymentSubTotal(props.item.payments))}}</div>
                                                            </v-flex>
                                                        </v-layout>

                                                    </v-flex>
                                                </v-layout>

                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </template>
                        </ajax-data-iterator>

                        <div v-if="payment_records.show_export_btn" class="text-xs-left pt-2">
<!--                            <v-btn color="primary" :href="exportPaymentRecordUrl(false)" target="_blank">{{$t('action.export')}} (Pdf)</v-btn>-->
                            <v-btn color="primary" :href="exportPaymentRecordUrl(true)" target="_blank">{{$t('action.export')}} (Excel)</v-btn>
                        </div>

                    </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item
                key="event_media">
                <v-card flat>
                    <v-card-text>
                        <v-layout>
                            <v-btn
                                    fab
                                    fixed
                                    right
                                    bottom
                                    color="primary"
                                    class="mb-5"
                                    @click="addEventMedia()"
                            >
                                <v-icon>add</v-icon>
                            </v-btn>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-btn-toggle v-model="media_list.filter_type" mandatory>
                                    <v-btn flat :value="0">
                                        {{$t('app.all')}}
                                    </v-btn>
                                    <v-btn flat :value="1">
                                        {{$t('media_type.vr_image')}}
                                    </v-btn>
                                    <v-btn flat :value="2">
                                        {{$t('media_type.normal_image')}}
                                    </v-btn>
                                </v-btn-toggle>
                            </v-flex>

                            <template v-for="media in event_data.media">
                                <v-flex xs12 sm6 md4 v-if="media_list.filter_type == 0 || media.type == media_list.filter_type">
                                    <v-card>
                                        <v-img
                                                :src="getThumbnailUrl(media.file.absolute_url)"
                                                height="200px"
                                        >
                                            <v-container fluid class="pa-2">
                                                <v-chip color="primary" text-color="white" v-if="media.type == 1">{{$t('media_type.vr_image')}}</v-chip>
                                                <v-chip color="success" text-color="white" v-if="media.type == 2">{{$t('media_type.normal_image')}}</v-chip>
                                            </v-container>
                                        </v-img>

                                        <v-card-actions>
                                            {{media.name}}
                                            <v-spacer></v-spacer>
                                            <v-btn icon v-if="media.type == 1">
                                                <v-icon @click="openMediaVr(media)">visibility</v-icon>
                                            </v-btn>
                                            <v-btn icon v-if="media.type == 2">
                                                <v-icon @click="showImgLightBox(media.file.absolute_url)">visibility</v-icon>
                                            </v-btn>
                                            <v-menu
                                                transition="scale-transition"
                                                bottom
                                                left
                                            >
                                                <v-btn
                                                    slot="activator"
                                                    icon
                                                >
                                                    <v-icon>more_vert</v-icon>
                                                </v-btn>
                                                <v-list>
<!--                                                    <v-list-tile @click="renameMedia(media)"><v-icon class="pr-1">edit</v-icon> {{$t('action.rename')}}</v-list-tile>-->
                                                    <v-list-tile @click="editMedia(media)"><v-icon class="pr-1 fa-fw">edit</v-icon> {{$t('action.edit')}}</v-list-tile>
                                                    <v-list-tile @click="removeMedia(media)"><v-icon class="pr-1 fa-fw">delete</v-icon> {{$t('action.remove')}}</v-list-tile>
                                                    <v-list-tile @click="shareMedia(media)"><v-icon class="pr-1 pb-1 fa-fw">fab fa-whatsapp</v-icon> {{$t('action.share')}}</v-list-tile>
                                                </v-list>

                                            </v-menu>
<!--                                            <v-btn icon>-->
<!--                                                <v-icon>share</v-icon>-->
<!--                                            </v-btn>-->
                                        </v-card-actions>
                                    </v-card>
                                </v-flex>
                            </template>
                        </v-layout>
                    </v-card-text>

                </v-card>

            </v-tab-item>
            <v-tab-item
                key="story">
                <v-card flat>
                    <v-card-text>
                        <v-layout>
                            <v-btn
                                    fab
                                    fixed
                                    right
                                    bottom
                                    color="primary"
                                    class="mb-5"
                                    @click="addStory()"
                            >
                                <v-icon>add</v-icon>
                            </v-btn>
                        </v-layout>
                        <v-layout row wrap>
                            <template v-for="story in event_data.story">
                                <v-flex xs12 sm6 md4>
                                    <v-card>
                                        <v-card-title class="justify-center light-blue darken-1">
                                            <v-icon center size="80" color="white">
                                                fas fa-book-open
                                            </v-icon>
                                        </v-card-title>
                                        <v-card-actions>
                                            {{story.name}}
                                            <v-spacer></v-spacer>
                                            <v-btn @click="openStoryVr(story)" icon>
                                                <v-icon>visibility</v-icon>
                                            </v-btn>
                                            <v-menu
                                                    transition="scale-transition"
                                                    bottom
                                                    left
                                            >
                                                <v-btn
                                                        slot="activator"
                                                        icon
                                                >
                                                    <v-icon>more_vert</v-icon>
                                                </v-btn>
                                                <v-list>
                                                    <v-list-tile @click="editStory(story)"><v-icon class="pr-1 fa-fw">edit</v-icon> {{$t('action.edit')}}</v-list-tile>
<!--                                                    <v-list-tile><v-icon class="pr-1 fa-fw">delete</v-icon> {{$t('action.remove')}}</v-list-tile>-->
                                                    <v-list-tile @click="shareStory(story)"><v-icon class="pr-1 pb-1 fa-fw">fab fa-whatsapp</v-icon> {{$t('action.share')}}</v-list-tile>
                                                </v-list>
                                            </v-menu>
                                        </v-card-actions>
                                    </v-card>
                                </v-flex>
                            </template>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item
                    key="activity">

                <v-card flat>
                    <v-card-text>
                        <v-layout>
                            <v-btn
                                    fab
                                    fixed
                                    right
                                    bottom
                                    color="primary"
                                    class="mb-5"
                                    @click="addActivity()"
                            >
                                <v-icon>add</v-icon>
                            </v-btn>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-card class="elevation-0">
                                    <v-layout row wrap>

                                        <template v-for="(activity, index) in event_data.activities">
                                            <v-flex xs12 class="pb-0">
                                                <v-card class="registration-item">
                                                    <v-card-text primary-title class="py-4 pl-4">
                                                        <v-layout align-center>
                                                            <v-layout row wrap align-center>
                                                                <v-flex sm6 >
                                                                    <div class="font-weight-bold" style="font-size: 1.2em">
                                                                        {{activity.name}}
                                                                    </div>
                                                                    <div>{{$t('event.activity_quota')}}: {{activity.attendee_count}} / <template v-if="activity.quota">{{activity.quota}}</template><template v-else>{{$t('general.unlimited')}}</template></div>
                                                                </v-flex>
                                                                <v-flex sm6  class="text-xs-right">
                                                                    <v-btn flat icon @click="viewActivity(activity.id)">
                                                                        <v-icon>visibility</v-icon>
                                                                    </v-btn>
                                                                    <v-btn flat icon @click="editActivity(activity)">
                                                                        <v-icon>edit</v-icon>
                                                                    </v-btn>
                                                                    <v-btn flat icon @click="deleteActivity(activity.id)">
                                                                        <v-icon>delete</v-icon>
                                                                    </v-btn>
                                                                </v-flex>
                                                            </v-layout>

                                                        </v-layout>
                                                    </v-card-text>
                                                </v-card>
                                            </v-flex>

                                        </template>
                                    </v-layout>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>



            </v-tab-item>
        </v-tabs>

        <save-event-dialog
                ref="save_event_dialog"
                :event_item="current_event_item"
                :show_dialog="show_edit_event_dialog"
                :save_success_callback="save_event_success_callback"
                v-on:update:show_dialog="show_edit_event_dialog = $event"
        ></save-event-dialog>

        <save-story-dialog
            ref="save_story_dialog"
            :story_item="save_story_dialog.item"
            :media_list="save_story_dialog.media_list"
            :show_dialog="save_story_dialog.show"
            :event_id="event_data.id"
            :save_success_callback="save_story_dialog.success_callback"
            v-on:update:show_dialog="save_story_dialog.show = $event"
        ></save-story-dialog>

        <save-activity-dialog
            ref="save_activity_dialog"
            :activity_item="save_activity_dialog.item"
            :show_dialog="save_activity_dialog.show"
            :event_id="event_data.id"
            :save_success_callback="save_activity_dialog.success_callback"
            v-on:update:show_dialog="save_activity_dialog.show = $event"
        ></save-activity-dialog>

        <view-activity-dialog
            :show_dialog="view_activity_dialog.show"
            :activity_id="view_activity_dialog.activity_id"
            v-on:update:show_dialog="view_activity_dialog.show = $event"
        ></view-activity-dialog>

        <save-registration-dialog
                ref="save_registration_dialog"
                :event_id="event_data.id"
                :event_item="event_data"
                :registration_item="saveRegistrationDialog.item"
                :show_dialog="saveRegistrationDialog.show"
                :save_success_callback="save_registration_success_callback"
                v-on:update:show_dialog="saveRegistrationDialog.show = $event"
        >

        </save-registration-dialog>

        <v-dialog v-model="inviteDialog.show" scrollable persistent max-width="400px">
            <v-form id="invitationForm" ref="invitationForm" method="post" :action="inviteDialog.action" @success="sendSuccess">
                <input type="hidden" name="id" v-model="inviteDialog.invitation.id"/>
                <input type="hidden" name="event_id" v-model="event_data.id"/>
                <input type="hidden" name="method" v-model="inviteDialog.invitation.method"/>
                <input type="hidden" name="template" v-model="inviteDialog.invitation.template"/>
                <input type="hidden" name="schedule_type" v-model="inviteDialog.invitation.schedule_type"/>
                <template
                  v-for="(contact, i) in inviteDialog.invitation.contacts"
                >
                    <input
                      type="hidden"
                      name="contacts[]"
                      v-model="contact.id"
                      :key="i"
                    />
                </template>
                <v-card>
                    <v-toolbar dark color="primary">
                        <span class="headline">{{$t('event.invitation')}}</span>
                        <v-speed-dial
                                v-if="!inviteDialog.invitation.id"
                                id="invitation-speed-dialog"
                                absolute
                                right
                                bottom
                                direction="left"
                        >
                            <v-btn
                                    slot="activator"
                                    color="cyan"
                                    dark
                                    fab
                            >
                                <v-icon>add</v-icon>
                                <v-icon>close</v-icon>
                            </v-btn>
                            <v-tooltip bottom z-index="204">
                                <v-btn
                                        fab
                                        dark
                                        small
                                        color="green"
                                        @click="showEventPicker = true"
                                        slot="activator"
                                >
                                    <v-icon>far fa-calendar-alt</v-icon>
                                </v-btn>
                                <span>{{$t('event.invite_from_event')}}</span>
                            </v-tooltip>
                            <v-tooltip bottom z-index="204">
                                <v-btn
                                        fab
                                        dark
                                        small
                                        color="purple"
                                        @click="showGroupPicker = true"
                                        slot="activator"
                                >
                                    <v-icon>fa-users</v-icon>
                                </v-btn>
                                <span>{{$t('event.invite_from_group')}}</span>
                            </v-tooltip>
                            <v-tooltip bottom z-index="204">
                                <v-btn
                                        fab
                                        dark
                                        small
                                        color="indigo"
                                        @click="showContactPicker"
                                        slot="activator"
                                >
                                    <v-icon>fa-address-book</v-icon>
                                </v-btn>
                                <span>{{$t('event.invite_from_contact')}}</span>
                            </v-tooltip>
                        </v-speed-dial>
                        <v-btn
                                v-else
                                fab
                                absolute
                                right
                                bottom
                                color="error"
                                class="mr-2"
                                @click="deleteInvitation(inviteDialog.invitation.id)"
                        >
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text>
                        <!--<v-flex-->
                          <!--v-if="!inviteDialog.invitation.id"-->
                          <!--class="warning&#45;&#45;text"-->
                          <!--mt-2-->
                          <!--xs12-->
                        <!--&gt;-->
                            <!--<div><v-icon color="warning">fa-exclamation-circle fa-lg</v-icon> {{$t('app.msg_sms_charges_incurred')}}</div>-->
                        <!--</v-flex>-->

                        <v-list two-line>
                            <template v-for="(contact, index) in inviteDialog.invitation.contacts">
                                <v-list-tile
                                  :key="contact.id"
                                  avatar
                                >
                                    <v-list-tile-content>
                                        <v-list-tile-title v-text="contact.name"></v-list-tile-title>
                                        <v-list-tile-sub-title>
                                            <v-icon small>phone</v-icon>{{contact.areaCode}} {{contact.phone}}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action v-if="!inviteDialog.invitation.id">
                                        <v-icon @click="deleteContact(contact.id)">delete</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-action v-else-if="event_data.is_private">
                                        <v-layout>
                                            <v-icon @click="copyUrl(contact.shorten_url)" class="pa-1">far fa-copy</v-icon>
                                            <a :href="generateWhatsappLink(contact)" target="_blank"><v-icon class="pa-1">fab fa-whatsapp</v-icon></a>
                                            <!--<v-icon @click="sendSMS(contact.id)">fa-sms</v-icon>-->
                                        </v-layout>
                                    </v-list-tile-action>
                                    <v-list-tile-action v-else>
                                        <a :href="generateWhatsappLink(contact)" target="_blank"><v-icon class="pa-1">fab fa-whatsapp</v-icon></a>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-divider
                                  v-if="index + 1 < inviteDialog.invitation.contacts.length"
                                  :key="'divider' + contact.id"
                                ></v-divider>
                            </template>
                        </v-list>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="inviteDialog.show = false">{{$t('action.close')}}</v-btn>
                        <v-btn
                          v-show="!inviteDialog.invitation.id"
                          color="blue darken-1"
                          flat
                          type="submit"
                          :loading="inviteDialog.loading"
                        >
                            {{$t('action.confirm')}}
                        </v-btn>
                        <!--<v-btn color="primary" type="submit" ref="submit" flat :loading="loading">{{$t('form.submit')}}</v-btn>-->
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <v-dialog v-model="registration_detail_dialog.show" scrollable persistent max-width="600px" lazy :fullscreen="$vuetify.breakpoint.smAndDown">
            <v-card>
                <v-toolbar dark color="primary" style="z-index: 1">
                    <span class="headline">{{$t('event.registration_details')}}</span>

                    <v-speed-dial
                            id="reg_details_more_action"
                            fab
                            v-model="registration_detail_dialog.fab_btn"
                            direction="bottom"
                            absolute
                            bottom
                            right
                            :open-on-hover="false"
                            transition="slide-y-transition"
                    >
                        <v-btn
                                slot="activator"
                                v-model="registration_detail_dialog.fab_btn"
                                color="cyan"
                                dark
                                fab
                        >
                            <v-icon>more_vert</v-icon>
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-tooltip
                                v-if="registration_detail_dialog.item.pinned_to_top"
                                left z-index="204">
                            <v-btn
                                    fab
                                    dark
                                    color="success"
                                    small
                                    slot="activator"
                                    @click="registrationSetPinToTop(registration_detail_dialog.item, 0)"
                            >
                                <v-icon>fas fa-minus</v-icon>
                            </v-btn>
                            <span>{{$t('action.unpin_to_top')}}</span>
                        </v-tooltip>
                        <v-tooltip
                                v-else
                                left z-index="204">
                            <v-btn
                                    fab
                                    dark
                                    color="success"
                                    small
                                    slot="activator"
                                    @click="registrationSetPinToTop(registration_detail_dialog.item, 1)"
                            >
                                <v-icon>fas fa-arrow-up</v-icon>
                            </v-btn>
                            <span>{{$t('action.pin_to_top')}}</span>
                        </v-tooltip>

                        <v-tooltip left z-index="204">
                            <v-btn
                                    fab
                                    dark
                                    color="success"
                                    small
                                    @click="editRegistration(registration_detail_dialog.item)"
                                    slot="activator"
                            >
                                <v-icon>edit</v-icon>
                            </v-btn>
                            <span>{{$t('action.edit')}}</span>
                        </v-tooltip>
                        <v-tooltip left z-index="204">
                            <v-btn
                                    fab
                                    dark
                                    small
                                    color="red"
                                    @click="cancelRegistration(registration_detail_dialog.item)"
                                    slot="activator"
                            >
                                <v-icon>event_busy</v-icon>
                            </v-btn>
                            <span>{{$t('action.cancel')}}</span>
                        </v-tooltip>

                    </v-speed-dial>


                    <!--<v-btn-->
                            <!--fab-->
                            <!--absolute-->
                            <!--right-->
                            <!--bottom-->
                            <!--color="success"-->
                            <!--class="mr-2"-->
                            <!--@click="editRegistration(registration_detail_dialog.item)"-->
                    <!--&gt;-->
                        <!--<v-icon>edit</v-icon>-->
                    <!--</v-btn>-->
                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text>


                    <v-list two-line>
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-title>{{$t('registration.registration_status')}}</v-list-tile-title>
                                <v-list-tile-sub-title>
                                    <v-chip label :color="getRegistrationStatusColor(registration_detail_dialog.item.status)" text-color="white" small disabled>{{$t('registration_status.' + registration_detail_dialog.item.status)}}</v-chip>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-title>{{$t('event.registrant')}}</v-list-tile-title>
                                <v-list-tile-sub-title>
                                    {{registration_detail_dialog.item.full_contact_name}}
                                    <span v-if="registration_detail_dialog.item.pinned_to_top"> ({{$t('registration.pinned_to_top')}})</span>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="event_data.enable_custom_field">
                            <v-list-tile-content>
                                <v-list-tile-title>{{event_data.custom_field_label}}</v-list-tile-title>
                                <v-list-tile-sub-title>
                                    {{registration_detail_dialog.item.custom_field_value}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="event_data.enable_custom_field_2">
                            <v-list-tile-content>
                                <v-list-tile-title>{{event_data.custom_field_label_2}}</v-list-tile-title>
                                <v-list-tile-sub-title>
                                    {{registration_detail_dialog.item.custom_field_value_2}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="event_data.enable_custom_field_3">
                            <v-list-tile-content>
                                <v-list-tile-title>{{event_data.custom_field_label_3}}</v-list-tile-title>
                                <v-list-tile-sub-title>
                                    {{registration_detail_dialog.item.custom_field_value_3}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="registration_detail_dialog.item.activities.length">
                            <v-list-tile-content>
                                <v-list-tile-title>{{$t('event.activity')}}</v-list-tile-title>
                                <v-list-tile-sub-title>{{getActivityNames(registration_detail_dialog.item.activities)}}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="registration_detail_dialog.item.is_reserved">
                            <v-list-tile-content>
                                <v-list-tile-title>{{$t('event.attendees')}}</v-list-tile-title>
                                <v-list-tile-sub-title>{{registration_detail_dialog.item.attendee_count}}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>

                    <v-tabs v-if="registration_detail_dialog.item.is_reserved">
                        <v-tab key="attendees">
                            <v-icon size="16" class="mr-2">fas fa-user-edit</v-icon>
                            {{$t('event.named_attendees')}} ({{registration_detail_dialog.item.attendees.length}})
                        </v-tab>
                        <v-tab
                                v-if="show_payment_related"
                                key="payments"
                        >
                            <v-icon size="16" class="mr-2">far fa-money-bill-alt</v-icon>
                            {{$t('event.payments')}}
                        </v-tab>
                        <v-tab-item>
                            <v-card flat>
                                <!--<v-card-text class="py-0 text-xs-right">-->
                                    <!--<v-btn @click="showEditAttendeesDialog" class="mr-0" color="primary">-->
                                        <!--{{$t('event.edit_attendees_info')}}-->
                                    <!--</v-btn>-->
                                <!--</v-card-text>-->
                                <v-card-text>
                                    <attendee-list-view :items="registration_detail_dialog.item.attendees"></attendee-list-view>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item
                                v-if="show_payment_related"
                                key="payments"
                        >
                            <v-card flat>
                                <v-card-text>

                                    <template v-if="registration_detail_dialog.item.submitted_payment_method">

                                        <h4>{{$t('deposit_transaction.submitted_payment_method')}}</h4>
                                        <p>{{$t('payment_methods.' + registration_detail_dialog.item.submitted_payment_method)}}</p>

                                        <template v-if="registration_detail_dialog.item.submitted_payment_ref">
                                            <h4>{{$t('deposit_transaction.submitted_payment_reference')}}</h4>
                                            <p>{{registration_detail_dialog.item.submitted_payment_ref}}</p>
                                        </template>

                                        <template v-if="registration_detail_dialog.item.payment_receipt_file.length">
                                            <h4>{{$t('registration.upload_payment_receipt')}}:</h4>

                                            <v-layout :row="!$vuetify.breakpoint.smAndDown" :wrap="!$vuetify.breakpoint.smAndDown">
                                                <template v-for="payment_receipt_file in registration_detail_dialog.item.payment_receipt_file">
                                                    <v-card flat tile class="d-flex pa-1">
                                                        <v-img
                                                                height="100px"
                                                                width="100px"
                                                                :src="payment_receipt_file.absolute_url"
                                                                aspect-ratio="1"
                                                                class="grey lighten-2 receipt-image-grid"
                                                                @click="showImgLightBox(payment_receipt_file.absolute_url)"
                                                        ></v-img>
                                                    </v-card>
                                                </template>

                                            </v-layout>
                                        </template>
                                    </template>

                                    <deposit-transaction-view
                                            :registration_id="registration_detail_dialog.item.id"
                                            :default_payment_method="registration_detail_dialog.item.submitted_payment_method ? parseInt(registration_detail_dialog.item.submitted_payment_method) : null"
                                            :default_payment_reference="registration_detail_dialog.item.submitted_payment_ref"
                                            :after_action="after_transaction_change_action"
                                    >
                                    </deposit-transaction-view>

                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="registration_detail_dialog.show = false">{{$t('action.close')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="media_edit_dialog.show" scrollable persistent max-width="600px">
            <v-form ref="saveMediaForm" method="post" :action="media_edit_dialog.action" v-model="media_edit_dialog.form.valid" v-on:success="success_save_media">
                <v-card>
<!--                    <v-card-title-->
<!--                            class="headline blue darken-2 white&#45;&#45;text"-->
<!--                            primary-title-->
<!--                    >-->
<!--                        <div>{{$t('event.edit_media')}}</div>-->
<!--                    </v-card-title>-->
                    <v-toolbar card dark color="primary">
                        <v-toolbar-title>{{$t('event.edit_media')}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text class="v-dialog-body">
                        <input type="hidden" name="media_id" v-model="media_edit_dialog.item.id">
                        <input type="hidden" name="media_type" v-model="media_edit_dialog.item.type">

                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 v-if="media_edit_dialog.form.errors.general!==''">
                                    <v-alert
                                            :value="media_edit_dialog.form.errors.general!==''"
                                            type="error"
                                    >
                                        {{media_edit_dialog.form.errors.general}}
                                    </v-alert>
                                </v-flex>

                                <h2>{{$t('event.media_info')}}</h2>

                                <v-flex xs12>
                                    <v-text-field
                                            :label="$t('event.media_title')"
                                            v-model="media_edit_dialog.item.name"
                                            :rules="[rules.required]"
                                            :error-messages="media_edit_dialog.form.errors.title"
                                            name="title"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-textarea
                                            :label="$t('event.media_caption')"
                                            v-model="media_edit_dialog.item.caption"
                                            :error-messages="media_edit_dialog.form.errors.caption"
                                            auto-grow
                                            name="caption"
                                    >
                                    </v-textarea>
                                </v-flex>

                                <v-flex xs12>
                                    <label class="v-label sp-v-label">
                                        Media type
                                    </label>

                                    <div>
                                        <v-btn-toggle v-model="media_edit_dialog.item.type" mandatory>
                                            <v-btn flat :value="1">
                                                {{$t('media_type.vr_image')}}
                                            </v-btn>
                                            <v-btn flat :value="2">
                                                {{$t('media_type.normal_image')}}
                                            </v-btn>
                                        </v-btn-toggle>
                                    </div>

                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="media_edit_dialog.show = false">{{$t('action.close')}}</v-btn>
                        <v-btn color="blue darken-1" flat type="submit" :loading="media_edit_dialog.form.loading" :disabled="!media_edit_dialog.form.valid">{{$t('action.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <v-dialog v-model="name_list_dialog.show" scrollable persistent max-width="400px" lazy :fullscreen="$vuetify.breakpoint.smAndDown">
            <v-card>
<!--                <v-card-title-->
<!--                        class="headline blue darken-2 white&#45;&#45;text"-->
<!--                >-->
<!--                    <div>{{name_list_dialog.title}}</div>-->
<!--                </v-card-title>-->
                <v-toolbar card dark color="primary">
                    <v-toolbar-title>{{name_list_dialog.title}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text class="v-dialog-body">
                    <v-list>
                        <v-list-tile
                                v-for="(item, index) in name_list_dialog.names"
                                :key="index"
                                avatar
                        >
                            <v-list-tile-avatar>
                                <v-icon>person</v-icon>
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title>{{item}}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="name_list_dialog.show = false">{{$t('action.close')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <contact-picker
          v-model="contactPicker.show"
          :exclude="inviteDialog.invitation.contacts"
          :eventId="contactPicker.eventId"
          :groupId="contactPicker.groupId"
          @success="getContacts"
        >
        </contact-picker>

        <event-picker
          v-model="showEventPicker"
          @success="getEvent"
        >
        </event-picker>

        <group-picker
          v-model="showGroupPicker"
          @success="getGroup"
        >
        </group-picker>

        <upload-dialog
                v-model="eventMediaUploadDialog.show"
                :title="$t('upload.button')"
                accept="image/*"
                :maxSizeInMB="eventMediaUploadDialog.maxSizeInMB"
                :type="eventMediaUploadDialog.type"
                :multiple="eventMediaUploadDialog.multiple"
                ref="eventMediaUploadDialog"
                :postFields="eventMediaUploadDialog.postFields"
                @success="eventMediaUploadDialog.uploadSuccess"
        >
            <v-btn-toggle v-model="eventMediaUploadDialog.media_type" mandatory>
                <v-btn flat :value="1">
                    {{$t('media_type.vr_image')}}
                </v-btn>
                <v-btn flat :value="2">
                    {{$t('media_type.normal_image')}}
                </v-btn>
            </v-btn-toggle>
        </upload-dialog>

        <VueEasyLightbox
                :visible="imgLightBox.visible"
                :imgs="imgLightBox.img"
                :index="imgLightBox.index"
                @hide="hideImgLightBox"
        >
        </VueEasyLightbox>
    </v-container>
</template>

<script>
    import AjaxDataIterator from '~/components/widgets/data/AjaxDataIterator'
    import SaveEventDialog from '~/components/event/SaveEventDialog'
    import SaveStoryDialog from '~/components/event/story/SaveStoryDialog'
    import SaveRegistrationDialog from '~/components/event/registration/SaveRegistrationDialog'
    import ViewActivityDialog from "~/components/event/activity/ViewActivityDialog"
    import SaveActivityDialog from "~/components/event/activity/SaveActivityDialog"
    import MiniStatistic from '~/components/widgets/statistic/MiniStatistic'
    import RequestHandler from '~/utils/request-handler'
    import {UrlServices} from '~/utils/url-manager'
    import InvitationMethod from '~/components/enum/InvitationMethod.ts'
    import InvitationScheduleType from '../../enum/InvitationScheduleType.ts'
    import PaymentMethod from '~/components/enum/registration/PaymentMethod.ts'
    import PaymentStatus from '~/components/enum/registration/PaymentStatus.ts'
    import ContactPicker from '~/components/contact/ContactPicker'
    import GroupPicker from '~/components/contact/GroupPicker'
    import EventPicker from '~/components/event/EventPicker'
    import DepositTransactionView from '~/components/event/registration/DepositTransactionView'
    import AttendeeListView from '~/components/event/registration/AttendeeListView'
    import FormHandling from '~/utils/data/form-handling'
    import formatter from '~/utils/formatter'
    import UploadDialog from '~/components/common/UploadDialog.vue'
    import Utils from '~/utils'
    const qs = require('qs');
    import { isMobile } from 'mobile-device-detect';
    import OssStyler from "~/utils/images/oss-styler";
    import VueEasyLightbox from 'vue-easy-lightbox'
    import RegistrationStatus from "~/components/enum/registration/RegistrationStatus.ts";

    export default {
        name: "Manage",
        components: {
            AjaxDataIterator,
            SaveEventDialog,
            SaveRegistrationDialog,
            MiniStatistic,
            ContactPicker,
            EventPicker,
            GroupPicker,
            DepositTransactionView,
            AttendeeListView,
            UploadDialog,
            SaveStoryDialog,
            SaveActivityDialog,
            VueEasyLightbox,
            ViewActivityDialog
        },
        data() {
            return {
                utils: Utils,
                rules: {
                    // add (parseInt(value)===0) to allow user input zero
                    required: value => (!!value) || this.$t('form.field_required'),
                    required_allow_zero: value => (!!value || parseInt(value)===0) || this.$t('form.field_required')
                },
                event_data: {
                    start_timestamp: new Date(),
                    end_timestamp: new Date(),
                    stats: {
                        decline_count: 0,
                        maybe_count: 0,
                        attendee_count: 0,
                        registration_count: 0
                    },
                    is_private: 1,
                    media: []
                },
                attendee_list: {
                    items: [],
                    loading: true,
                    record_count: 0,
                    pagination: {
                        rowsPerPage: 5
                    },
                },
                registration_detail_dialog: {
                    show: false,
                    fab_btn: false,
                    item: {
                        id: 0,
                        contact_name: "",
                        attendee_count: 0,
                        attendees: [],
                        activities: [],
                        transaction_data: {},
                        pinned_to_top: 0,
                        status: RegistrationStatus.RESERVED,
                        is_reserved: true,
                        payment_receipt_file: []
                    },
                },
                media_list: {
                    filter_type: 0
                },
                media_edit_dialog: {
                    show: false,
                    action: UrlServices.createUrl({name: 'api_event_media_save'}),
                    form: {
                        valid: false,
                        loading: false,
                        errors: {
                            general: "",
                            title: "",
                            caption: "",
                        }
                    },
                    item: {
                        id: 0,
                    }
                },
                name_list_dialog: {
                    show: false,
                    title: "",
                    names: []
                },
                // registration_edit_attendees_dialog: {
                //     show: false,
                //     loading: false,
                //     guest_names: [
                //
                //     ],
                //     guest_phones: [
                //
                //     ],
                //     guest_ids: [
                //
                //     ]
                // },
                current_event_item: {},
                registration_url: "",
                show_edit_event_dialog: false,
                save_event_success_callback: function() {},
                save_story_dialog: {
                    show: false,
                    item: {},
                    media_list: {},
                    success_callback: function() {

                    }
                },
                save_registration_success_callback: function() {},
                save_activity_dialog: {
                    show: false,
                    item: {},
                    success_callback: function() {

                    }
                },
                view_activity_dialog: {
                    show: false,
                    activity_id: 0,
                },
                saveRegistrationDialog: {
                    show: false,
                    item: {}
                },
                show_invitations: false,
                show_payment_related: false,
                invitations: {
                    items: [],
                    loading: false
                },
                inviteDialog: {
                    show: false,
                    loading: false,
                    action: UrlServices.createUrl({name: 'api_event_invitation_save'}),
                    invitation: {
                        id: 0,
                        method: InvitationMethod.SMS,
                        template: this.$t('event.invitation_sms'),
                        schedule_type: InvitationScheduleType.Immediately,
                        contacts: []
                    }//,
                    //contacts: []
                },
                contactPicker: {
                    show: false,
                    eventId: 0,
                    groupId: 0
                },
                showEventPicker: false,
                showGroupPicker: false,
                PaymentStatus: PaymentStatus,
                payment_status_items: [],
                payment_method_items: [],
                registration_status_items: [],
                registration_sorting_items: [
                    {
                        value: 'name',
                        text: this.$t('registration.contact_name')
                    },
                    {
                        value: 'reg_date',
                        text: this.$t('registration.registration_date')
                    }
                ],
                registration_list: {
                    searching: false,
                    params: {
                        event_id: this.$route.query.event_id,
                        contact_name: null,
                        payment_status: [],
                        registration_status: [
                            RegistrationStatus.RESERVED,
                            RegistrationStatus.MAYBE,
                            RegistrationStatus.EXCUSED
                        ],
                        sort_by: 'reg_date'
                    }
                },
                payment_records: {
                    show_export_btn: false,
                    searching: false,
                    total_received: 0,
                    params: {
                        event_id: this.$route.query.event_id,
                        payment_methods: []
                    }
                },
                eventMediaUploadDialog: {
                    show: false,
                    multiple: true,
                    uploadSuccess: function() {},
                    type: "event_media",
                    maxSizeInMB: 100,
                    media_type: 1,
                    postFields: {
                        event_id: null,
                        media_type: 1
                    }
                },
                imgLightBox: {
                    img: '',
                    visible: false,
                    index: 0
                }
            };
        },
        computed: {
            stat_attendee_count_text() {
                let text = this.event_data.stats.attendee_count.toString();
                if(this.event_data.has_quota_limit){
                    text += " / " + this.event_data.quota;
                }
                return text;
            },
            stat_attendee_count_title() {
                let title = this.$t('event.attendees');
                if(this.event_data.has_quota_limit){
                    title += " / " + this.$t('event.quota_short');
                }
                return title;
            },
            get_attendee_list_url() {
                return UrlServices.createUrl({name: 'api_event_attendee_list'});
            },
            get_url_query() {
                return {
                    'event_id': this.$route.query.event_id
                };
            },
            get_invitations_url() {
                return UrlServices.createUrl({name: 'api_event_invitation_list'});
            },
            get_registrations_url() {
                return UrlServices.createUrl({name: 'api_registration_list'});
            },
            get_payment_received_url() {
                return UrlServices.createUrl({name: 'api_get_payment_received'});
            },
            get_event_location() {
                return this.event_data.location_text ? this.event_data.location_text : this.$t('registration.location_tbc');
            },
            eventStarted() {
                return false;
                // return getApp.$moment().diff(this.event_data.start_timestamp * 1000) > 0;
            },
            isEventFull() {
                let is_full = false;
                if(this.event_data.has_quota_limit && this.event_data.remain_quota <= 0){
                    is_full = true;
                }
                return is_full;
            },
            has_navigation_share() {
                return !!window.navigator.share;
            },
            get_event_period() {
                let start_time = getApp.$moment(this.event_data.start_timestamp * 1000).format('llll');

                let start_date = getApp.$moment(this.event_data.start_timestamp * 1000).format('LL');
                let end_date = getApp.$moment(this.event_data.end_timestamp * 1000).format('LL');

                let end_time = (start_date === end_date) ? getApp.$moment(this.event_data.end_timestamp * 1000).format('LT') : getApp.$moment(this.event_data.end_timestamp * 1000).format('llll');

                return start_time + ' - ' + end_time;
            }
        },
        methods: {
            getEventData() {
                let me = this;
                let event_id = this.$route.query.event_id;
                this.eventMediaUploadDialog.postFields.event_id = event_id;
                window.getApp.$emit('APP_START_LOADING');
                if(event_id){
                    RequestHandler.Get(UrlServices.createUrl({name: 'api_event_get'}), {
                        event_id: event_id
                    }, {
                        'success': function(data) {
                            let event_data = data.event_data;
                            let contact_select_list = event_data.contact_select_list;
                            _.each(contact_select_list, function(item){
                                formatter.parsePhone(item);
                                item.search_field = (item.phone.replace(' ', '') + item.name)
                            });

                            let activity_name_list = {};
                            _.each(event_data.activities, function(item){
                                activity_name_list[item.id] = item.name;
                            });
                            event_data['activity_name_list'] = activity_name_list;

                            me.event_data = event_data;
                        },
                        'error': function() {
                            getApp.snackbar = {
                                show: true,
                                color: 'red',
                                text: me.$t('app.msg_not_found'),
                                timeout: 10000
                            };
                            getApp.$router.replace({name: 'event_list'});
                        },
                        'complete': function() {
                            window.getApp.$emit('APP_STOP_LOADING');
                        }
                    });
                } else {
                    this.$router.replace({name: '404'});
                }
            },
            processRegistrationItem: function(item){
                item.show_menu = false;
                let contact = item.contact;
                if(contact){
                    formatter.parsePhone(contact);
                }
                return item;
            },
            showRegistration(item){
                this.registration_detail_dialog.item.id = null;
                this.$nextTick(function(){
                    let attendees = item.attendees;
                    attendees.map(x => {
                        if(x.phone && !x.areaCode){
                            formatter.parsePhone(x);
                        }
                    });
                    item.is_reserved = item.status == RegistrationStatus.RESERVED;
                    this.registration_detail_dialog.item = _.extend({}, item);
                    this.registration_detail_dialog.show = true;
                });


            },
            copyUrl(url) {
                let me = this;
                this.$copyText(url).then(function () {
                    getApp.snackbar = {
                        show: true,
                        color: 'green',
                        text: me.$t('app.msg_copy_success'),
                        timeout: 3000
                    };
                }, function (e) {
                    console.log('Can not copy');
                    console.log(e);
                })
            },
            gotoUrl(url) {
                window.open(url, '_blank');
            },
            shareRegistration() {
                let time_info = this.$t('event.invitation_time_info', {
                    value: this.get_event_period
                });
                let location_info = this.$t('event.invitation_location_info', {
                    value: this.event_data.location_text ? this.event_data.location_text : this.$t('registration.location_tbc')
                });

                let message = this.$t('registration.msg_share_event_text', {
                    'event_name': this.event_data.title,
                    'time_info': time_info,
                    'location_info': location_info
                });

                this.shareUrl(this.registration_url, message);
            },
            shareUrl(url, text) {
                navigator.share({
                    url: url,
                    text: text
                })
            },
            whatsappShareFunction(message) {
                window.open("https://api.whatsapp.com/send?text=" + encodeURIComponent(message))
            },
            shareWithWhatsapp() {
                let time_info = this.$t('event.invitation_time_info', {
                    value: this.get_event_period
                });
                let location_info = this.$t('event.invitation_location_info', {
                    value: this.event_data.location_text ? this.event_data.location_text : this.$t('registration.location_tbc')
                });


                let message = this.$t('registration.msg_share_event', {
                    'event_name': this.event_data.title,
                    'url': this.registration_url,
                    'time_info': time_info,
                    'location_info': location_info
                });
                this.whatsappShareFunction(message);
            },
            shareWithFacebook() {
                window.open("https://www.facebook.com/sharer/sharer.php?u=" + this.registration_url, null, 'width=640,height=400');
            },
            editEvent() {
                this.current_event_item = _.extend({}, this.event_data);
                this.show_edit_event_dialog = true;
            },
            // getInvitations() {
            //     console.log('getInvitations');
            //     let params = {
            //         page: this.invitations.page,
            //         event_id: this.event_data.id
            //     };
            //     let me = this;
            //     new RequestHandler.Get( UrlServices.createUrl({name: 'api_event_invitation_list'}), params, {
            //         'success': function(data) {
            //             //me.invitations.record_count = parseInt(data['record_count']);
            //             me.invitations.items = data['data'];
            //             //me.attendee_list.loading = false;
            //         }
            //     });
            // },
            editRegistration(item) {
                if(item == null){
                    this.saveRegistrationDialog.item = item;
                }else{
                    this.saveRegistrationDialog.item = _.extend({}, item);
                }
                this.saveRegistrationDialog.show = true;
            },
            registrationSetPinToTop(item, is_pin_to_top) {
                let me = this;
                getApp.loading_overlay = true;
                RequestHandler.Post(UrlServices.createUrl({name: 'api_registration_set_is_pinned_to_top'}), {
                    registration_id:  item.id,
                    pinned_to_top: is_pin_to_top
                }, {
                    'success': function(data) {
                        let msg;
                        let updated_reg = data['registration'];
                        if(updated_reg['pinned_to_top']){
                            msg = me.$t('app.msg_pin_to_top_success');
                        } else {
                            msg = me.$t('app.msg_unpin_to_top_success');
                        }

                        getApp.snackbar = {
                            show: true,
                            color: 'green',
                            text: msg,
                            timeout: 3000
                        };

                        me.showRegistration(updated_reg);
                        me.$refs.registrationListIterator.getDataFromApi();
                    },
                    'complete': function() {
                        getApp.loading_overlay = false;
                    }
                });
            },
            cancelRegistration(item) {
                let me = this;
                this.$root.$confirm(
                    this.$t('event.cancel_registration'),
                    this.$t('event.cancel_registration_msg'))
                    .then((confirm) => {
                        if(confirm){
                            RequestHandler.Post(UrlServices.createUrl({name: 'api_registration_cancel'}), {
                                registration_id: item.id
                            }, {
                                'success': function(data) {
                                    getApp.snackbar = {
                                        show: true,
                                        color: 'green',
                                        text: me.$t('app.msg_cancel_success'),
                                        timeout: 3000
                                    };
                                    me.registration_detail_dialog.show = false;
                                    me.event_data = _.extend({}, data['event']);
                                    me.$refs.registrationListIterator.getDataFromApi();
                                    if(me.$refs.paymentRecordIterator){
                                        me.$refs.paymentRecordIterator.getDataFromApi();
                                    }
                                }
                            });
                        }
                    });
            },
            exportRegistrantsList() {

                let me = this;

                let message = me.$t('registration.msg_registration_info', {
                    'event_name': me.event_data.title,
                    'event_location': me.get_event_location,
                    'event_datetime': this.get_event_period,
                });

                if(me.event_data.registrants.length || me.event_data.maybe_registrants.length || me.event_data.excused_registrants.length){
                    message += "\n\n" + me.$t('registration.num_of_reg_label', {
                        'num': me.event_data.registrants.length,
                    });

                    if(me.event_data.registrants.length){
                        message += "\n" + me.$t('registration.num_of_attend_reg', {
                            'num': me.event_data.registrants.length,
                        });
                    }

                    if(me.event_data.maybe_registrants.length){
                        message += "\n" + me.$t('registration.num_of_maybe_reg', {
                            'num': me.event_data.maybe_registrants.length,
                        });
                    }

                    if(me.event_data.excused_registrants.length){
                        message += "\n" + me.$t('registration.num_of_excuse_reg', {
                            'num': me.event_data.excused_registrants.length,
                        });
                    }
                }

                if(me.event_data.display_registrants){
                    message += "\n\n" + me.$t('registration.msg_registration_list_url', {
                        'url': me.event_data.registration_details_url,
                    });
                }

                message += "\n\n" + me.$t('registration.msg_registration_url', {
                    'url': me.event_data.registration_url,
                });

                if(this.has_navigation_share){
                    navigator.share({
                        text: message
                    })
                } else {
                    window.open("https://api.whatsapp.com/send?text=" + encodeURIComponent(message))
                }

                // let me = this;
                // let params = _.extend({}, me.registration_list.params);
                // params['export'] = 1;
                // getApp.loading_overlay = true;
                // RequestHandler.Get(me.get_registrations_url, params,{
                //     'success': function(data) {
                //         let registrations = data['data'];
                //         let confirmed_registration_count = 0;
                //         let excused_registration_count = 0;
                //         let maybe_registration_count = 0;
                //         let attendee_count = 0;
                //         let confirmed_registrant_names = [];
                //         let excused_registrant_names = [];
                //         let maybe_registrant_names = [];
                //         _.each(registrations, function(reg){
                //             let registrants_and_attendee = reg.contact_name;
                //
                //             if(reg.attendees.length == 1){
                //                 if(reg.contact_name !== reg.attendees[0].name){
                //                     registrants_and_attendee += "\n- " + reg.attendees[0].name;
                //                 }
                //             }else if(reg.attendees.length > 1){
                //                 let attendee_names = [];
                //                 _.each(reg.attendees, function(attendee){
                //                     attendee_names.push('- ' + attendee.name);
                //                 });
                //                 registrants_and_attendee += "(" + reg.attendee_count + ")";
                //                 registrants_and_attendee += "\n" + attendee_names.join("\n");
                //             }
                //             if(reg.status == RegistrationStatus.RESERVED){
                //                 confirmed_registrant_names.push(registrants_and_attendee);
                //                 attendee_count += parseInt(reg.attendee_count);
                //                 confirmed_registration_count++;
                //             }else if(reg.status == RegistrationStatus.MAYBE) {
                //                 maybe_registrant_names.push(registrants_and_attendee);
                //                 maybe_registration_count++;
                //             }else if(reg.status == RegistrationStatus.EXCUSED){
                //                 excused_registrant_names.push(registrants_and_attendee);
                //                 excused_registration_count++;
                //             }
                //         });
                //         let confirmed_registrant_content = "";
                //         let maybe_registrant_content = "";
                //         let excused_registrant_content = "";
                //         if(confirmed_registrant_names.length){
                //             confirmed_registrant_content = confirmed_registrant_names.join("\n");
                //         }else {
                //             confirmed_registrant_content = "--";
                //         }
                //         if(maybe_registrant_names.length){
                //             maybe_registrant_content = maybe_registrant_names.join("\n");
                //         }else {
                //             maybe_registrant_content = "--";
                //         }
                //         if(excused_registrant_names.length){
                //             excused_registrant_content = excused_registrant_names.join("\n");
                //         }else {
                //             excused_registrant_content = "--";
                //         }
                //
                //
                //         let message = me.$t('registration.msg_export_registration_list', {
                //             'event_name': me.event_data.title,
                //             'event_location': me.get_event_location,
                //             'event_datetime': getApp.$moment(me.event_data.start_timestamp * 1000).format('LLL'),
                //             'reg_count': confirmed_registration_count,
                //             'maybe_reg_count': maybe_registration_count,
                //             'excused_reg_count': excused_registration_count,
                //             'attendee_count': attendee_count,
                //             'confirmed_registrant_content': confirmed_registrant_content,
                //             'maybe_registrant_content': maybe_registrant_content,
                //             'excused_registrant_content': excused_registrant_content,
                //             'url': me.registration_url,
                //         });
                //
                //         window.open("https://api.whatsapp.com/send?text=" + encodeURIComponent(message))
                //     },
                //     'complete': function() {
                //         getApp.loading_overlay = false;
                //     }
                // });
            },
            showInviteDialog(invitation) {
                //console.log('showInviteDialog', invitation);
                this.inviteDialog.invitation.contacts = (!_.isEmpty(invitation)) ? invitation.contacts.map(x => {
                    if (!x.contact.areaCode) {
                        formatter.parsePhone(x.contact);
                    }
                    x.contact.shorten_url = x.shorten_url;
                    x.contact.token = x.token;
                    return x.contact;
                }) : [];
                this.inviteDialog.invitation.id = invitation.id;
                this.inviteDialog.show = true;
            },
            deleteInvitation(id) {
                let me = this;
                this.$root.$confirm(
                    this.$t('event.delete_invitation'),
                    this.$t('event.delete_invitation_msg')).then((confirm) => {
                    if(confirm){
                        RequestHandler.Post(UrlServices.createUrl({name: 'api_event_invitation_delete'}),{
                            invitation_id: id
                        },{
                            'success': function(){
                                getApp.snackbar = {
                                    show: true,
                                    color: 'green',
                                    text: me.$t('app.msg_delete_success'),
                                    timeout: 3000
                                };
                                me.inviteDialog.show = false;
                                me.$refs.invitationIterator.getDataFromApi();
                            }
                        });
                    }
                });
            },
            sendSuccess() {
                //console.log('sendSuccess');
                this.inviteDialog.show = false;
                this.$refs.invitationIterator.getDataFromApi();
            },
            showContactPicker() {
                this.contactPicker.eventId = 0;
                this.contactPicker.groupId = 0;
                this.contactPicker.show = true
            },
            getContacts(contacts) {
                //console.log('getContacts', contacts);
                this.contactPicker.show = false;
                if (this.inviteDialog.invitation.contacts) {
                    this.inviteDialog.invitation.contacts = [].concat(this.inviteDialog.invitation.contacts, contacts);
                } else {
                    this.inviteDialog.invitation.contacts = contacts;
                }
            },
            deleteContact(contactId) {
                //console.log('deleteContact', contactId);
                let filteredContacts = _.filter(this.inviteDialog.invitation.contacts, x => {
                    return x.id !== contactId;
                });
                //console.log('filteredContacts', filteredContacts);
                this.inviteDialog.invitation.contacts = [].concat(filteredContacts);
            },
            getPaymentStatusColor(status) {
                let color = "";
                switch(status) {
                    case PaymentStatus.NOT_PAID:
                        color = "red";
                        break;
                    case PaymentStatus.PARTIALLY_PAID:
                        color = "yellow darken-2";
                        break;
                    case PaymentStatus.PENDING_TO_PROCESS:
                        color = "amber darken-2";
                        break;
                    default:
                    case PaymentStatus.PAID:
                        color = "green";
                        break;

                }

                return color;
            },
            getRegistrationStatusColor(status) {
                let color = "";
                switch(status) {
                    case RegistrationStatus.MAYBE:
                        color = "primary";
                        break;
                    case RegistrationStatus.EXCUSED:
                        color = "error";
                        break;
                    case RegistrationStatus.RESERVED:
                    default:
                        color = "green";
                        break;
                }

                return color;
            },
            // sendSMS() {
            //
            // },
            generateWhatsappLink(contact) {
                let time_info = this.$t('event.invitation_time_info', {
                    value: this.get_event_period
                });
                let location_info = this.$t('event.invitation_location_info', {
                    value: this.event_data.location_text ? this.event_data.location_text : this.$t('registration.location_tbc')
                });

                //console.log('generateWhatsappLink', contact);
                let msg = this.$t('event.invitation_whatsapp', {
                    name: contact.name,
                    event: this.event_data.title,
                    url: this.registration_url,
                    time_info: time_info,
                    location_info: location_info
                });
                //console.log('msg', msg);
                let whatsappUrl = 'https://api.whatsapp.com/send/'
                    + ('?phone=' + contact.areaCode.replace('+', '') + contact.phone.replace(/\s/, ''))
                    + '&text=' + encodeURIComponent(msg);
                //console.log('whatsappUrl', whatsappUrl);
                return whatsappUrl;
            },
            getPaymentReceivedCallback(data) {
                this.payment_records.show_export_btn = data['record_count']>0;
                this.payment_records.searching = false;
                this.payment_records.total_received = parseInt(data['total_received']);
            },
            getRegistrationCallback(){
                this.registration_list.searching = false;
            },
            getPaymentSubTotal(payments){
                let amount = 0;
                _.each(payments, function(payment){
                    amount += parseInt(payment['payment_amount']);
                });
                return amount;
            },
            searchRegistrations: _.debounce(function() {
                this.registration_list.searching = true;
                this.$nextTick(function() {
                    this.$refs.registrationListIterator.getDataFromApi();
                });
            }, 1000),
            searchPayments: _.debounce(function() {
                this.payment_records.searching = true;
                this.$nextTick(function() {
                    this.$refs.paymentRecordIterator.getDataFromApi();
                });
            }, 500),
            exportPaymentRecordUrl(is_excel) {

                let name = is_excel ? "export_excel" : "export";

                let params = _.extend({
                    [name]: 1
                }, this.payment_records.params);

                return UrlServices.createUrl({
                    name: 'api_get_payment_received'
                }) + '?' + qs.stringify(params);
            },
            exportEventAttendeeListUrl() {
                let params = {
                    event_id: this.$route.query.event_id
                };
                return UrlServices.createUrl({
                    name: 'api_event_export_attendee_list'
                }) + '?' + qs.stringify(params);
            },
            // allInvitationsSent(contacts) {
            //     console.log('allInvitationSent', contacts);
            //     return !_.some(contacts, x => {
            //         return !!x.sent_time;
            //     })
            // },
            getEvent(event) {
                this.showEventPicker = false;
                this.contactPicker.groupId = 0;
                this.contactPicker.eventId = event.id;
                this.contactPicker.show = true;
            },
            getGroup(group) {
                this.showGroupPicker = false;
                this.contactPicker.eventId = 0;
                this.contactPicker.groupId = group.id;
                this.contactPicker.show = true;
            },
            after_transaction_change_action() {
                this.$refs.registrationListIterator.getDataFromApi();
                this.$refs.paymentRecordIterator.getDataFromApi();
            },
            addStory() {
                this.save_story_dialog.item = null;
                this.save_story_dialog.show = true;
            },
            editStory(story) {
                this.save_story_dialog.item = story;
                this.save_story_dialog.show = true;
            },
            addActivity() {
                this.save_activity_dialog.item = null;
                this.save_activity_dialog.show = true;
            },
            editActivity(activity) {
                this.save_activity_dialog.item = _.extend({}, activity);
                this.save_activity_dialog.show = true;
            },
            viewActivity(activity_id) {
                this.view_activity_dialog.activity_id = activity_id;
                this.view_activity_dialog.show = true;
            },
            deleteActivity(activity_id) {
                let me = this;
                this.$root.$confirm(
                    this.$t('event.remove_activity'),
                    this.$t('event.remove_activity_msg'))
                    .then((confirm) => {
                        if(confirm){
                            RequestHandler.Post(UrlServices.createUrl({name: 'api_event_activity_delete'}), {
                                activity_id: activity_id
                            }, {
                                'success': function(data) {
                                    getApp.snackbar = {
                                        show: true,
                                        color: 'green',
                                        text: me.$t('app.msg_cancel_success'),
                                        timeout: 3000
                                    };
                                    let item_index = null;
                                    let item = _.find(me.event_data.activities, (x, index) => {
                                        if(x.id == activity_id){
                                            item_index = index;
                                        }
                                        return x.id == activity_id;
                                    });
                                    if(item){
                                        me.event_data.activities.splice(item_index, 1);
                                    }
                                }
                            });
                        }
                    });
            },
            shareStory(story) {
                let url = UrlServices.createAbsoluteUrl({name: 'vr'}) + '?story_id=' + story['encrypted_id'];
                this.whatsappShareFunction(url);
            },
            addEventMedia() {
                let me = this;
                this.eventMediaUploadDialog.show = true;
                this.eventMediaUploadDialog.uploadSuccess = function(data) {
                    _.each(data, function(item){
                        me.event_data.media.push(item.result);
                    });

                    me.event_data.media = _.extend([], me.event_data.media);
                }
            },
            editMedia(media) {
                this.media_edit_dialog.show = true;
                media.type = parseInt(media.type);
                this.media_edit_dialog.item = _.extend({}, media);
            },
            shareMedia(media) {
                let url = UrlServices.createAbsoluteUrl({name: 'vr'}) + '?media_id=' + media['encrypted_id'];
                this.whatsappShareFunction(url);
            },
            removeMedia(media) {
                let me = this;
                this.$root.$confirm(
                    this.$t('event.delete_media'),
                    this.$t('event.delete_media_msg'))
                    .then((confirm) => {
                        if(confirm){
                            RequestHandler.Post(UrlServices.createUrl({name: 'api_event_media_delete'}),{
                                media_id: media.id
                            }, {
                                'success': function(data) {
                                    getApp.snackbar = {
                                        show: true,
                                        color: 'green',
                                        text: me.$t('app.msg_delete_success'),
                                        timeout: 3000
                                    };
                                    me.event_data.media = _.filter(me.event_data.media, x => {
                                        return x.id !== media.id;
                                    });
                                }
                            });
                        }
                    });
            },
            openMediaVr(media) {
                let url = UrlServices.createAbsoluteUrl({name: 'vr'}) + '?media_id=' + media['encrypted_id'];
                window.open(url, '_blank');
            },
            openStoryVr(story) {
                let url = UrlServices.createAbsoluteUrl({name: 'vr'}) + '?story_id=' + story['encrypted_id'];
                window.open(url, '_blank');
            },
            success_save_media(data) {
                this.media_edit_dialog.show = false;
                let item_index = null;
                let item = _.find(this.event_data.media, (x, index) => {
                    if(x.id == data.id){
                        item_index = index;
                    }
                    return x.id == data.id;
                });

                if(item){
                    this.event_data.media[item_index] = data;
                }

                this.event_data.media = _.extend([], this.event_data.media);

                let message = this.$t('app.msg_edit_success');
                getApp.snackbar = {
                    show: true,
                    color: 'green',
                    text: message,
                    timeout: 3000
                };
            },
            getThumbnailUrl(url) {
                // return "https://images.weserv.nl/?url=" + url + "&w=400";
                return OssStyler.getThumbnailResUrl(url);
            },
            showImgLightBox(url) {
                this.imgLightBox.img = url;
                this.imgLightBox.visible = true;
            },
            hideImgLightBox() {
                this.imgLightBox.visible = false
            },
            getTotalRegistrationCount() {
                return parseInt(this.event_data.stats.registration_count) + parseInt(this.event_data.stats.maybe_count) + parseInt(this.event_data.stats.decline_count);
            },
            showAttendeeNameList() {
                let title = this.$t('registration.num_of_attendees', {'num': this.event_data.stats.attendee_count});
                let names = [];
                let non_named_count = 0;
                _.each(this.event_data.registrants, function(registrant){
                    names = names.concat(registrant.attendee_names);
                    non_named_count += parseInt(registrant.non_named_guest_count);
                });
                if(non_named_count){
                    title = title + " (" + this.$t('event.num_of_non_named', {'number': non_named_count}) + ")";
                }

                this.showNameList(title, names);
            },
            showRegistrationNameList() {
                let title = this.$t('registration.num_of_registrants', {'num': this.getTotalRegistrationCount()});
                let names = [];
                _.each(this.event_data.registrants, function(registrant){
                    names.push(registrant.name);
                });
                _.each(this.event_data.maybe_registrants, function(registrant){
                    names.push(registrant.name);
                });
                _.each(this.event_data.excused_registrants, function(registrant){
                    names.push(registrant.name);
                });
                this.showNameList(title, names);
            },
            showMaybeNameList() {
                let title = this.$t('registration.num_of_maybe', {'num': this.event_data.maybe_registrants.length});
                let names = [];
                _.each(this.event_data.maybe_registrants, function(registrant){
                    names.push(registrant.name);
                });
                this.showNameList(title, names);
            },
            showExcuseNameList() {
                let title = this.$t('registration.num_of_excused', {'num': this.event_data.excused_registrants.length});
                let names = [];
                _.each(this.event_data.excused_registrants, function(registrant){
                    names.push(registrant.name);
                });
                this.showNameList(title, names);
            },
            showNameList(title, names) {
                if(names.length){
                    this.name_list_dialog.title = title;
                    this.name_list_dialog.names = names;
                    this.name_list_dialog.show = true;
                }
            },
            getActivityNames(act_ids) {
                let acts = [];
                let me = this;

                _.each(act_ids, function(a_id){
                    if(me.event_data.activity_name_list[a_id]){
                        acts.push(me.event_data.activity_name_list[a_id]);
                    }
                });

                return acts.join(', ');
            }
        },
        watch: {
            "save_story_dialog.show": function(show) {
                if(!show){
                    this.save_story_dialog.item = false;
                }
            },
            event_data: function(event_data) {
                this.registration_url = event_data.registration_url;
                this.show_invitations =  event_data.is_private || event_data.enable_select_name_from_invitations;
                this.show_payment_related = event_data.price_per_head > 0;
            },
            'event_data.media': function(data) {
                this.save_story_dialog.media_list = _.keyBy(data, 'id');
            },
            'eventMediaUploadDialog.media_type': function(val){
                this.eventMediaUploadDialog.postFields.media_type = val;
            },
            'registration_list.params.registration_status': function(values, old_values) {
                let me = this;
                if(!values.length){
                    this.$nextTick(() => {
                        me.registration_list.params.registration_status = old_values;
                    });

                }
            }
        },
        mounted() {
            let me = this;
            this.save_event_success_callback = function(data){

                let contact_select_list = data.contact_select_list;
                _.each(contact_select_list, function(item){
                    formatter.parsePhone(item);
                    item.search_field = (item.phone.replace(' ', '') + item.name)
                });

                me.event_data = _.extend({}, _.extend(me.event_data, data));
                let message = this.$t('app.msg_edit_success');

                me.$refs.registrationListIterator.getDataFromApi();

                getApp.snackbar = {
                    show: true,
                    color: 'green',
                    text: message,
                    timeout: 3000
                };
            };

            this.save_story_dialog.success_callback = function(data){
                let message = "";
                let is_new_record = data.is_new_record;

                if(is_new_record){
                    message = me.$t('app.msg_create_success');
                    me.event_data.story.push(data.data);
                }else{
                    //
                    message = me.$t('app.msg_edit_success');

                    let item_index = null;
                    let item = _.find(me.event_data.story, (x, index) => {
                        if(x.id == data.data.id){
                            item_index = index;
                        }
                        return x.id == data.data.id;
                    });
                    if(item){
                        me.event_data.story[item_index] = data.data;
                    }
                }
                getApp.snackbar = {
                    show: true,
                    color: 'green',
                    text: message,
                    timeout: 3000
                };
            };

            this.save_activity_dialog.success_callback = function(data) {
                let message = "";
                let is_new_record = data.is_new_record;

                if(is_new_record){
                    message = me.$t('app.msg_create_success');
                    me.event_data.activities.push(data.data);
                }else{
                    //
                    message = me.$t('app.msg_edit_success');

                    let item_index = null;
                    let item = _.find(me.event_data.activities, (x, index) => {
                        if(x.id == data.data.id){
                            item_index = index;
                        }
                        return x.id == data.data.id;
                    });
                    if(item){
                        me.event_data.activities[item_index] = data.data;
                    }
                }
                getApp.snackbar = {
                    show: true,
                    color: 'green',
                    text: message,
                    timeout: 3000
                };
            };

            this.save_registration_success_callback = function(data){
                let event_data = data['event'];

                let contact_select_list = event_data.contact_select_list;
                _.each(contact_select_list, function(item){
                    formatter.parsePhone(item);
                    item.search_field = (item.phone.replace(' ', '') + item.name)
                });
                let activity_name_list = {};
                _.each(event_data.activities, function(item){
                    activity_name_list[item.id] = item.name;
                });
                event_data['activity_name_list'] = activity_name_list;

                me.event_data = event_data;

                let item_index = null;
                let registration_item = data['registration'];
                _.each(me.$refs.registrationListIterator.items, (x, index) => {
                    if(x.id == registration_item.id){
                        item_index = index;
                        return false;
                    }
                });
                let attendees = registration_item.attendees;
                formatter.parsePhone(registration_item.contact);
                attendees.map(x => {
                    if(x.phone && !x.areaCode){
                        formatter.parsePhone(x);
                    }
                });
                if(item_index !== null){
                    me.$refs.registrationListIterator.updateItem(item_index, registration_item);
                    me.showRegistration(registration_item);
                }else{
                    me.$refs.registrationListIterator.getDataFromApi();
                }
                if(me.$refs.paymentRecordIterator){
                    me.$refs.paymentRecordIterator.getDataFromApi();
                }
            };

            _.each(Utils.getEnumValues(PaymentStatus), function(item){
                me.payment_status_items.push({
                    value: item,
                    text : me.$t('payment_status.' + item)
                });
            });

            _.each(Utils.getEnumValues(PaymentMethod), function(item){
                me.payment_method_items.push({
                    value: item,
                    text : me.$t('payment_methods.' + item)
                });
            });

            _.each(Utils.getEnumValues(RegistrationStatus), function(item){
                me.registration_status_items.push({
                    value: item,
                    text: me.$t('registration_status.' + item)
                });
            });

            this.getEventData();

            new FormHandling(this, "invitationForm");

            new FormHandling(this, "saveMediaForm", this.media_edit_dialog.form);
        }
    }
</script>

<style>

    .heading-total-received {
        font-weight: bold;
    }

    .payment-record-row {
        /*background-color: #EEE;*/
        margin-bottom: 8px!important;
        /*padding: 4px;*/
    }

    .payment-record-row .flex{
        background-color: #EEE;
        padding: 5px 12px!important;
    }

    #invitation-speed-dialog {
        transform: translateY(60px);
    }

    #invitation-speed-dialog > .v-btn--floating .v-btn__content {
        height: 23px;
    }

    .registration-info-wrapper {
        width: 100%;
    }

    .registration-item {
        cursor: pointer;
    }

    #reg_details_more_action {
        transform: translateY(60px);
    }

    #reg_details_more_action > .v-btn--floating .v-btn__content {
        height: 25px;
    }

    .registration-status-wrapper {
        position: absolute;
        top: -15px;
        left: -15px;
    }

    .receipt-image-grid {
        border: 1px solid #ccc!important;
        cursor: pointer;
    }
</style>